import { render, staticRenderFns } from "./EventRequirements.vue?vue&type=template&id=cc146402&"
import script from "./EventRequirements.vue?vue&type=script&lang=js&"
export * from "./EventRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc146402')) {
      api.createRecord('cc146402', component.options)
    } else {
      api.reload('cc146402', component.options)
    }
    module.hot.accept("./EventRequirements.vue?vue&type=template&id=cc146402&", function () {
      api.rerender('cc146402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/EventRequirements.vue"
export default component.exports